import React, { Component, Fragment } from "react";
import { inject, observer } from "mobx-react";
import { Button, Paper, AppBar, Tabs, Tab, Badge } from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import { withStyles } from "@material-ui/core/styles";

import Heading from "../../Heading";
import ConsultantTable from "./ConsultantTable";
import ConsultantInvitationModal from "./ConsultantInvitationModal";
import "./ConsultantContainer.css";

import { ProfileRelationType } from "../../../types/enum";

const styles = theme => ({
    tabBadge: {
        padding: "0 8px"
    },
    badge: {
        top: "50%",
        right: -16,
        backgroundColor: "#ff9800",
        color: "white"
    }
});

@inject("templateStore", "agentConsultantStore", "userInvitationStore", "profileStore")
@observer
class ConsultantContainer extends Component {
    state = {
        invitationModalState: false,
        activeTab: 0,
        searchQuery: ""
    };

    openInvitationModal = () => {
        this.props.agentConsultantStore.resetInvitationData();
        this.setState({ invitationModalState: true });
    };
    closeInvitationModal = () => this.setState({ invitationModalState: false });

    constructor(props) {
        super(props);
        this.props.agentConsultantStore.resetData();
        this.props.userInvitationStore.resetInvitations();
    }

    componentDidMount() {
        var currentProfile = this.props.profileStore.getCurrentProfile();

        this.props.templateStore.showLoadingScreen();
        Promise.all([
            this.props.userInvitationStore.getMyUserInvitation(ProfileRelationType.AgentConsultant.ordinal, currentProfile.id),
            this.props.agentConsultantStore.getAgentConsultants()
        ]).then(() => {
            this.props.templateStore.hideLoadingScreen();
        });
    }

    handleTabChange = (event, value) => {
        this.setState({ activeTab: value, searchQuery: "" });
    };

    handleSearchChange = (e) => {
        this.setState({ searchQuery: e.target.value });
    };

    getActiveCount = () => {
        const { agentConsultants } = this.props.agentConsultantStore;
        return agentConsultants.filter(x => x.accepted).length;
    };

    getPendingCount = () => {
        const { agentConsultants } = this.props.agentConsultantStore;
        const { invitations } = this.props.userInvitationStore;
        const pendingConsultants = agentConsultants.filter(x => !x.accepted);
        const filteredInvitations = invitations.filter(inv => 
            !agentConsultants.find(x => x?.consultantEmail === inv?.invitedEmail)
        );
        return pendingConsultants.length + filteredInvitations.length;
    };

    render() {
        const { activeTab, searchQuery } = this.state;
        const { classes } = this.props;
        const pendingCount = this.getPendingCount();

        return (
            <Fragment>
                <Heading title="My Consultants">
                    <Button 
                        variant="contained" 
                        color="primary" 
                        className="pull-right"
                        onClick={this.openInvitationModal}
                    >
                        Add Consultant
                    </Button>
                </Heading>

                <Paper style={{ position: "relative" }}>
                    <AppBar position="static" elevation={2} style={{ backgroundColor: "#3A3B3D" }}>
                        <Tabs 
                            value={activeTab} 
                            onChange={this.handleTabChange} 
                            indicatorColor="primary" 
                            textColor="secondary"
                            scrollable
                            scrollButtons="off"
                            classes={{
                                root: "tabs-root",
                                indicator: "tabs-indicator"
                            }}
                        >
                            <Tab 
                                value={0} 
                                label="ACTIVE CONSULTANTS" 
                                classes={{ selected: "tab-selected" }} 
                            />
                            <Tab 
                                value={1} 
                                label={
                                    <span className={classes.tabBadge}>
                                        PENDING INVITATIONS
                                        {pendingCount > 0 && (
                                            <Badge 
                                                badgeContent={pendingCount} 
                                                color="primary"
                                                classes={{ badge: classes.badge }}
                                                style={{ marginLeft: 20 }}
                                            />
                                        )}
                                    </span>
                                } 
                                classes={{ selected: "tab-selected" }} 
                            />
                        </Tabs>
                    </AppBar>

                    {activeTab === 0 && (
                        <div className="consultant-search-bar">
                            <div className="consultant-search-wrapper">
                                <SearchIcon className="consultant-search-icon" />
                                <input
                                    type="text"
                                    className="consultant-search-input"
                                    placeholder="Search consultants by name or email..."
                                    value={searchQuery}
                                    onChange={this.handleSearchChange}
                                />
                            </div>
                        </div>
                    )}

                    <ConsultantTable 
                        activeTab={activeTab === 0 ? "active" : "pending"} 
                        searchQuery={searchQuery}
                    />
                </Paper>

                <ConsultantInvitationModal 
                    open={this.state.invitationModalState} 
                    onClose={this.closeInvitationModal} 
                />
            </Fragment>
        );
    }
}

export default withStyles(styles)(ConsultantContainer);
